import {DesktopOutlined, MobileOutlined} from '@ant-design/icons/lib';
import {Button, Card, Form, Radio} from 'antd';
import {Account, AccountBrandingInput, PaymentMethods, useProvidersQuery} from 'api/generated';
import {Spacer, Spinner, Stack} from 'components';
import {unique} from 'lib/utils';
import React, {useState} from 'react';
import {config} from 'stage.config';
import styled from 'styled-components';
import {useDebounce} from 'use-debounce';

type Props = {
  values: AccountBrandingInput;
  account: Account;
};

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const IFrame = styled.iframe`
  width: 154%;
  height: 154%;
  transform: scale(0.65);
  transform-origin: left top;
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
`;

const Container = styled(Card)<{isMobilePreview: boolean}>`
  width: ${(props) => (props.isMobilePreview ? '250px' : '100%')};
  background: #f0f4f5;
  height: 665px;
  overflow: hidden;
  position: relative;
  margin: 5px auto 0;
  transition: width 0.3s ease 0s;
`;

const hiddenPaymentMethods = [PaymentMethods.COFIDIS];

export const PaymentPagePreview: React.FC<Props> = ({values, account}) => {
  const [isMobilePreview, setMobilePreview] = useState(false);
  const {data, loading} = useProvidersQuery({variables: {accountId: account.id}});
  const [{logoUrl, accentColor, bgColor}] = useDebounce(values, 250);
  const paymentMethods =
    data?.providers
      ?.filter((p) => p.enabled && !hiddenPaymentMethods.includes(p.paymentMethod!))
      .map((p) => p.paymentMethod)
      .sort((m) => (m === PaymentMethods.CARD ? 1 : -1)) || [];
  const params = {
    shopLogoUrl: logoUrl,
    accentColor,
    bgColor,
    paymentMethods: unique(paymentMethods),
    shopName: account?.publicBusinessDetails?.companyName || 'My company',
    language: account.language
  };
  const base64params = btoa(JSON.stringify(params));
  const previewUrl = `${config.paymentPagePreviewUrl}#${base64params}`;

  return (
    <Form.Item
      label={
        <Stack fullWidth>
          <span>Payment page preview</span>
          <Spacer />
          <Button size="small" href={previewUrl} target="_blank">
            Open in new tab
          </Button>
          <RadioGroup
            style={{display: 'flex'}}
            size="small"
            onChange={(e) => setMobilePreview(e.target.value)}
            value={isMobilePreview}
            buttonStyle="solid">
            <RadioButton value={false}>
              <DesktopOutlined /> Desktop
            </RadioButton>
            <RadioButton value={true}>
              <MobileOutlined /> Mobile
            </RadioButton>
          </RadioGroup>
        </Stack>
      }>
      <Container isMobilePreview={isMobilePreview}>
        {loading ? (
          <Spinner />
        ) : (
          <IFrame src={previewUrl} style={{background: bgColor || '#f0f4f5'}} />
        )}
      </Container>
    </Form.Item>
  );
};
